import React from "react";

const ImageTexte = ({ input }) => {
  return <section className='image-texte'>ImageTexte</section>;
};

export default ImageTexte;
